module.exports = __webpack_public_path__ + "static/media/lunch.326ceaaa.gif";